export default {
  Language: {
    ru: 'Русский',
    en: 'English',
    fr: 'Français',
  },
  Common: {
    ReturnToShop: 'Return to store',
  },
  Brand: {
    Title: 'Order payment',
    DescriptionLabel: 'Order description',
    Description: 'Payment for order №{{order}}',
    DescriptionNamed: 'Payment for order №{{order}} at {{merchant}}',
    DateLabel: 'Created on',
  },
  CardPage: {
    Title: 'Pay by bank card',
    AmountLabel: 'Amount due',
  },
  FormField: {
    CardNumber: 'Card number',
    CardMonthYear: 'Expiry date',
    CardCVC: 'CVV',
    ShowCvc: 'Show CVV',
    HideCvc: 'Hide CVV',
  },
  FormError: {
    Card: {
      pan: {
        required: 'Fill in the field',
        invalid: 'Invalid card number',
      },
      name: {
        required: 'Fill in the field',
        invalid: 'Use Latin letters, spaces, dots, or hyphens (up to 30 characters)',
      },
      cvc: {
        required: 'Fill in the field',
        invalid: 'Fill in the field',
      },
      expiry: {
        required: 'Fill in the field',
        month: {
          invalid: 'Value must be from 01 to 12',
        },
        year: {
          invalid: 'Current or upcoming years',
        },
      },
    },
  },
  PaymentStatus: {
    Title: {
      complete: 'Payment successful',
      partial_complete: 'Payment partially completed',
      failed: 'Payment failed',
      pending: 'Checking the payment',
    },
    Text: {
      complete: 'A payment of {{amount}} has been processed successfully. The receipt has been sent to your email.',
      partial_complete: 'A payment of {{amount}} was only partially processed. Please contact the store for details.',
      failed: 'We could not complete the payment. Try again or contact the bank that issued your card',
      pending: 'This will only take a few seconds. Please do not close the page.',
    },
    AmountLabel: {
      complete: 'Paid',
      partial_complete: 'Paid',
      failed: 'Amount due',
      pending: 'Amount due',
    },
  },
  Action: {
    Pay: 'Pay',
    Retry: 'Try again',
  },
  FatalError: {
    SomethingWentWrong: 'Something went wrong.',
    Code: {
      NO_TERMINALS_AVAILABLE: 'No terminals are available for this payment method.',
      FORM_PAY_ALREADY_SUBMITED: 'Please return to the store to retry payment.',
      FORM_PAY_ALREADY_SUBMITTED: 'Please return to the store to retry payment.',
      COMMON_ERROR: 'Error processing payment.',
      DUPLICATE_ORDER_ERROR: 'An order with this number already exists.',
      ROUTE_ERROR: 'This payment cannot be processed at this time.',
    },
  },
}
